import { UntypedFormGroup } from '@angular/forms';

/**
 * Helper for form methods
 */
export class FormHelper {
  form: UntypedFormGroup;

  /**
   * Constructor
   * @param form Set the formgroup which needs 'helping'
   */
  constructor(form: UntypedFormGroup) {
    this.form = form;
  }

  /**
   * Checks whether a field in a form has a valid value
   * @param form The form which the field belongs to
   * @param field The field to check validity
   * @param formSubmitAttempted Whether the form has been submitted or not
   */
  isFieldValid(field: string, formSubmitAttempted: boolean) {
    return (
      (!this.form.get(field)?.valid && this.form.get(field)?.touched) ||
      (this.form.get(field)?.untouched && formSubmitAttempted)
    );
  }

  /**
   * Returns the css class for an invalid field
   * @param field The field to check validity
   * @param formSubmitAttempted Whether the form has been submitted or not
   */
  isFieldValidCss(field: string, formSubmitAttempted: boolean) {
    return {
      'has-error': this.isFieldValid(field, formSubmitAttempted),
      //'has-feedback': this.isFieldValid(field, formSubmitAttempted)
    };
  }

  /**
   * Checks whether an ornamentum dropdown field in a form has a valid value
   * @param form The form which the field belongs to
   * @param field The field to check validity
   * @param formSubmitAttempted Whether the form has been submitted or not
   */
  isOrnamentumDropdownValid(field: string, formSubmitAttempted: boolean) {
    return (
      (!this.form.get(field)?.valid && !this.form.get(field)?.pristine) ||
      (this.form.get(field)?.pristine && formSubmitAttempted)
    );
  }

  /**
   * Returns the css class for an invalid field
   * @param field The field to check validity
   * @param formSubmitAttempted Whether the form has been submitted or not
   */
  isOrnamentumDropdownValidCss(field: string, formSubmitAttempted: boolean) {
    return {
      'has-error': this.isOrnamentumDropdownValid(field, formSubmitAttempted),
      //'has-feedback': this.isFieldValid(field, formSubmitAttempted)
    };
  }
}
